import React from "react";
import Header from './components/Header'
import Home from './components/Home'
import './App.css';
import Cryptotable from "./components/Cryptotable";
import Heroworks  from "./components/Heroworks";


function App() {
  return (
    <div className="App">
      < Header />
      < Home />
      < Cryptotable />
      <Heroworks />
      
    </div>
  );
}

export default App;
